module.exports = __webpack_public_path__ + "img/ИФ-1(А)-017.8d9cf373.png";